import SearchCard from './SearchCard'
export default SearchCard
